import type { CSSProperties } from 'react';
import { Icon, type IconName } from './Icon';

interface IconBtnProps {
  name: IconName;
  onClick?: () => void;
  title?: string;
  active?: boolean;
  size?: number;
  style?: CSSProperties;
}

export function IconBtn({ name, onClick, title, active, size = 32, style }: IconBtnProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      style={{
        width: size,
        height: size,
        border: '1px solid transparent',
        background: active ? 'var(--bx-surface-2)' : 'transparent',
        color: active ? 'var(--bx-primary)' : 'var(--bx-text-body)',
        borderRadius: 8,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        ...style,
      }}
    >
      <Icon name={name} size={15} />
    </button>
  );
}
